/**
 * @description 事件码上报函数
 * @param {{acode: number, clkParam:string}} param 
 */
export const sendAction = (param) => {
    if(window.sohuSpm && window.sohuSpm.sendAction){
        window.sohuSpm.sendAction(param)
    }
}

